export const GLOBAL_NAVIGATION = 'Global.Navigation';
export const CRM_SURVEYS_SHOW_IN_MENU = 'CRM.Surveys.ShowInMenuColumn';
export const CRM_SURVEYS_TABS = 'CRM.Survey.tabs';
export const CRM_SURVEYS_SHOW_CONNECT_SURVEYS = 'CRM.Surveys.ShowConnectSurveys';
